<template>
    <div>
        <TheBanner :title="this.$lang.supportTitle"
                   :description="this.$lang.supportSubtitle"
                   image="cover.jpeg"/>
        <GridView id="grid"
                  size="155px"
                  class="body-block"
                  :data="gridData"/>
    </div>
</template>

<script>
	import TheBanner from "@/components/TheBanner";
	import GridView from "@/components/GridView";

	export default {
		name: "Support",
		components: {GridView, TheBanner},
		data() {
			return {
				gridData: [
					{
						name: this.$lang.supportPhone,
						icon: "call",
						link: "tel:+86075788837571"
					},
					{
						name: this.$lang.supportChat,
						icon: "chat",
						link: "http://wpa.qq.com/msgrd?v=3&uin=804182774&site=qq&menu=yes"
					},
					{
						name: this.$lang.supportEmail,
						icon: "email",
						link: "mailto:info@moco-ink.com"
					},
					{
						name: this.$lang.supportMap,
						icon: "place",
						link: "https://amap.com/place/B02F50UNLD"
					},
					{
						name: this.$lang.supportDownload,
						icon: "download",
						link: "/downloads/"
					},
					{
						name: this.$lang.supportFax,
						icon: "print",
						link: "fax:+86.757.88837599"
					}
				]
			};
		}
	}
</script>

<style scoped lang="scss">
    #grid {
        @media #{$tablet} {
            margin-top: 32px;
        }

        @media #{$tablet-inv} {
            margin-top: 64px;
        }
    }

    #grid::v-deep .grid-card {
        font-family: $sans-serif;
    }

    #grid::v-deep .card-name > div::first-line {
        font-family: $serif;
        font-size: 20px;
    }
</style>